export const frontendRoutes = {
  home: "/",
  tutors: "/tuteurs",
  courseBySlug: "/cours/:slug",
  courseByCitySubject: "/cours/:citySlug/:subjectSlug",
  courseTutorDetail: "/cours/:citySlug/:subjectSlug/:tutorSlug",
  connexion: "/connexion",
  inscription: "/inscription",
  verificationEmail: "/verification-email",
  forgotPassword: "/mot-de-passe-oublie",
  resetPassword: "/reset-password",
  contact: "/contact",
  demande: "/demande",
  mentionsLegales: "/mentions-legales",
  cgu: "/cgu",
  blog: "/blog",
  blogPost: "/blog/:slug",
  pressReleases: "/press-releases",
  pressReleasePost: "/press-releases/:slug",
  devenirProfesseur: "/devenir-professeur",
  devenirProfesseurFeature: "/devenir-professeur/fonctionnalites/:featureSlug",
  discoverProfLinker: "/decouvrir-proflinker",
  profLinker: "/proflinker",
  courseParticuliersNsi: "/cours-particuliers-nsi",
  courseParticuliersMaths: "/cours-particuliers-mathematiques",
  courseParticuliersPhysics: "/cours-particuliers-physique-chimie",
  courseParticuliersSubject: "/cours-particuliers-:subject",
  dashboard: "/tableau-de-bord",
  dashboardListingNew: "/tableau-de-bord/annonces/nouvelle",
  dashboardListingEdit: "/tableau-de-bord/annonces/:id",
  onboarding: "/onboarding",
  publicProfile: "/profil/:userId",
  admin: "/admin",
  deconnexion: "/deconnexion",
  lateCancellationConfirm: "/late-cancellation/confirm",
  lateCancellationContest: "/late-cancellation/contest",
} as const;

export const preloadLikelyRoutePaths = [
  frontendRoutes.demande,
  frontendRoutes.tutors,
  frontendRoutes.blog,
  frontendRoutes.contact,
  frontendRoutes.connexion,
  frontendRoutes.inscription,
  frontendRoutes.discoverProfLinker,
  frontendRoutes.profLinker,
] as const;
